<script>
  import NavBar from "../components/Navigation/NavBar.svelte";
  import { Router, Link, Route, navigate} from "svelte-routing";
  import Program from "../pages/Program.svelte";
  import Challenges from "../pages/Challenges.svelte";
  import Submit from "../pages/Submit.svelte";
  import Login from "../pages/Login.svelte";
  import { getFlamelinkWearTesterByPassword, getFlamelinkChallenges } from "../services/flamelink";
  import { onMount } from "svelte";

  export let url = "";

  $: user = null;
  $: weeklyChallenges = [];
  $: loginFinished = false;

  function login(password) {
    return getFlamelinkWearTesterByPassword(password).then(wearTester => {
      if(wearTester == null) {
        return Promise.resolve(false)
      }
      user = Object.keys(wearTester).map(key => wearTester[key])[0]; // removes key and exposes data from response object --> ( { QDCI40AIej59dF: {...data} }.. ) <-- probably a more readable way to do this haha
      localStorage.setItem('id_code', password)
      if(user != null) {
        // navigate('/wear-testing/program')
      }
      loginFinished = true;
      return Promise.resolve(user != null)
    })
  }

  const onSubmitPassword = async (password) => {
    return login(password)
  }

  getFlamelinkChallenges().then(challenges => {
    weeklyChallenges = Object.keys(challenges).map(key => { return challenges[key] })
    console.log(weeklyChallenges)
  })

  onMount(() => {
    let code = localStorage.getItem("id_code")
    login(code)
  })
</script>

<Router url="{url}">
  <NavBar user={user} />
  <div>
    <Route path="wear-testing/program" component="{Program}" />
    <Route path="wear-testing/challenges"><Challenges weeklyChallenges={weeklyChallenges}/></Route>
    <Route path="wear-testing/submit"><Submit loginFinished={loginFinished} user={user} weeklyChallenges={weeklyChallenges} /></Route>
    <Route path="wear-testing/login"><Login  onSubmitPassword={onSubmitPassword} /></Route>
  </div>
</Router>
